var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9678 0.595954C2.42656 -0.198632 3.57344 -0.198631 4.0322 0.595955L5.83854 3.72463C6.29729 4.51922 5.72385 5.51245 4.80634 5.51245L1.19366 5.51245C0.276148 5.51245 -0.297295 4.51922 0.16146 3.72463L1.9678 0.595954Z",
    fill: "#F4F5F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownOpen);
export default __webpack_public_path__ + "static/media/dropdown-open.c9bac9e264fab7d4b499a34acbfc7de6.svg";
export { ForwardRef as ReactComponent };